define.alias("shared/components/shared/post/secondary/activity/wrapper", "calendar/components/shared/post/secondary/activity/wrapper");